const withFilter = (baseKey, filter = null) => [baseKey, filter ?? null];

export const QUERY_KEY_BASES = Object.freeze({
    counters: "counters",
    featuredWalks: "featured-walks",
    mapWalks: "map-walks",
    mapWalkers: "map-walkers",
    mapGroupWalks: "map-group-walks",
    mapGroupMembers: "map-group-members",
    filterWalkLevelOptions: "filter-walk-level-options",
    liveNotifications: "liveNotifications",
    walkTable: "walk-table",
    groupWalkTable: "group-walk-table",
    sponsorsTable: "sponsors-table",
    cityProclamationsTable: "city-proclamations-table",
});

export const QUERY_KEYS = Object.freeze({
    counters: [QUERY_KEY_BASES.counters],
    featuredWalks: [QUERY_KEY_BASES.featuredWalks],
    mapWalks: [QUERY_KEY_BASES.mapWalks],
    mapWalkers: [QUERY_KEY_BASES.mapWalkers],
    mapGroupWalks: [QUERY_KEY_BASES.mapGroupWalks],
    mapGroupMembers: [QUERY_KEY_BASES.mapGroupMembers],
    filterWalkLevelOptions: [QUERY_KEY_BASES.filterWalkLevelOptions],
    liveNotifications: [QUERY_KEY_BASES.liveNotifications],

    walkTableBase: [QUERY_KEY_BASES.walkTable],
    groupWalkTableBase: [QUERY_KEY_BASES.groupWalkTable],
    sponsorsTableBase: [QUERY_KEY_BASES.sponsorsTable],
    cityProclamationsTableBase: [QUERY_KEY_BASES.cityProclamationsTable],

    walkTable: (filter = null) => withFilter(QUERY_KEY_BASES.walkTable, filter),
    groupWalkTable: (filter = null) => withFilter(QUERY_KEY_BASES.groupWalkTable, filter),
    sponsorsTable: (filter = null) => withFilter(QUERY_KEY_BASES.sponsorsTable, filter),
    cityProclamationsTable: (filter = null) => withFilter(QUERY_KEY_BASES.cityProclamationsTable, filter),
});

export const QUERY_INVALIDATION_GROUPS = Object.freeze({
    walkJoin: [
        QUERY_KEYS.counters,
        QUERY_KEYS.featuredWalks,
        QUERY_KEYS.mapWalks,
        QUERY_KEYS.mapWalkers,
        QUERY_KEYS.walkTableBase,
    ],
    groupWalkJoin: [
        QUERY_KEYS.counters,
        QUERY_KEYS.mapGroupWalks,
        QUERY_KEYS.mapGroupMembers,
        QUERY_KEYS.groupWalkTableBase,
    ],
});

export default QUERY_KEYS;
